module.exports = __webpack_public_path__ + "img/trips-3.be5cd8d5.gif";